import React from 'react';
import PropTypes from 'prop-types';
import setInnerHTML from 'utils/setInnerHTML';
import classNames from 'classnames';
import { LANGUAGES } from 'config/types/prop';
import Link from 'components/link';
import withStyles from 'isomorphic-style-loader/withStyles';
import { formatDate } from 'utils/dateUtils';
import I18n from 'components/i18n';
import { isRetinaDisplay, isWindows } from 'utils/environment';

import styles from './articleHeader.css';
const excerptStyles = classNames(
  styles.excerpt,
  {
    [styles.isWindowsNonRetina]: isWindows() && !isRetinaDisplay(),
  },
);

const ArticleHeader = ({
  articleDate,
  articlePath,
  authorLink,
  authorName,
  currentEdition,
  excerpt,
  isArticlePage,
  title,
  isInProductMagazine,
}) => (
  <header className={styles.wrapper}>
    {isArticlePage ?
      <h1
        className={styles.heading}
        dangerouslySetInnerHTML={setInnerHTML(title)} // eslint-disable-line react/no-danger
      />
      :
      <div className={styles.heading}>
        <Link
          to={articlePath}
          dangerouslySetInnerHTML={setInnerHTML(title)} // eslint-disable-line react/no-danger
        />
      </div>
    }
    <div
      className={excerptStyles}
      dangerouslySetInnerHTML={setInnerHTML(excerpt)} // eslint-disable-line react/no-danger
    />
    <div className={styles.container}>
      {authorName && <div className={styles.author}>
        <div>
          <I18n
            field="by"
            defaultText="by"
          />
          {(isArticlePage && isInProductMagazine) ?
            <>&nbsp;{authorName}</> :
            <Link to={authorLink}>&nbsp;{authorName}</Link>
          }
        </div>
        <div className={styles.separator} />
        {isArticlePage && <div className={styles.articleDate}>
          {formatDate(articleDate, currentEdition)}
        </div>}
      </div>}
    </div>
  </header>
);

ArticleHeader.propTypes = {
  articleDate: PropTypes.string.isRequired,
  articlePath: PropTypes.string,
  authorName: PropTypes.string.isRequired,
  authorLink: PropTypes.string.isRequired,
  currentEdition: LANGUAGES,
  excerpt: PropTypes.string.isRequired,
  isArticlePage: PropTypes.bool,
  title: PropTypes.string.isRequired,
  isInProductMagazine: PropTypes.bool.isRequired,
};

ArticleHeader.defaultProps = {
  articleAbsoluteLink: '',
  articlePath: '',
  articleImage: '',
  currentEdition: 'en',
  isArticlePage: false,
};

export default withStyles(styles)(ArticleHeader);
